"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_STORE_IMAGE = void 0;
var client_1 = require("@apollo/client");
var MinimalStoreFragment_1 = require("../fragments/MinimalStoreFragment");
exports.UPDATE_STORE_IMAGE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateStoreImage($input: UpdateStoreImageInput!) {\n    updateStoreImage(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateStoreImage($input: UpdateStoreImageInput!) {\n    updateStoreImage(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"])), MinimalStoreFragment_1.MINIMAL_STORE_FRAGMENT);
var templateObject_1;
